import { IonContent, IonInput, IonPage, IonText,IonSpinner } from "@ionic/react"
import { useEffect, useState, useMemo } from "react"
import { Modal } from "react-bootstrap"
import { useHistory } from "react-router"
import DataTable from "react-data-table-component"
import service from "../../../Service/service"
import Head from "../../Header"
import Sidebar from "../../Sidebar"

const AllApproval: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [data, setData] = useState([]);
    const [empName, setEmpName] = useState("");
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [loading,setloading]=useState(false)
    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    useEffect(() => {
        ViewHRAllApproval();
    }, []);

    const ViewHRAllApproval = () => {
        setloading(true);
        service.HRGetAllApproval(localStorage.getItem("SignupEmpId"))
            .then((response) => {
                console.log(response);
                if (response.data.Status === "200") {
                    setData(response.data.Data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                // This code will execute whether the promise is resolved or rejected
                setTimeout(() => {
                    setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                }, 500); // Adjust the timeout duration as needed
            });
    };
    const back = () => {
        history.goBack();
    }
    const [leaveType, setLeaveType] = useState("");
    const [status, setStatus] = useState("");
    const [approvedBy, setApprovedBy] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setTodate] = useState("");
    const [leaveReason, setLeaveReason] = useState("");
    const [reportingPerson, setReportingPerson] = useState("");
    const [remarks, setRemarks] = useState("");
    const [noOfDays, setNoOfDays] = useState("");

    const openmodal = (itm: any) => {
        setModalopen(true);
        service.GetLeaveDetailsById(itm.id)
            .then((response) => {
                console.log(response, "lmlml")
                if (response.data.Status === "200") {
                    setLeaveType(response.data.Data.leaveType.leaveType);
                    setStatus(response.data.Data.leaveStatus.status);
                    setFromDate(response.data.Data.fromDate);
                    setTodate(response.data.Data.toDate);
                    setEmpName(response.data.Data.empName)
                    setLeaveReason(response.data.Data.reason);
                    setReportingPerson(response.data.Data.reportingPerson[0])
                    setNoOfDays(response.data.Data.noOfDays);
                    setRemarks(response.data.Data.remarks);
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const closemodal = () => {
        setModalopen(false);
        setLeaveType("");
        setStatus("");
        setFromDate("");
        setTodate("");
        setLeaveReason("");
        setReportingPerson("");
        setNoOfDays("");
    }

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: true,
            width: "100px",
        },
        {
            name: "Name",
            selector: (itm: any) => itm.empName,
            sortable: true,
            // width: "150px"
        },
        {
            name: "Leave Type ",
            selector: (itm: any) => itm.leaveType.leaveType,
            sortable: true,
        },
        {
            name: "Days/Hours ",
            selector: (itm: any) => itm.noOfDays,
            sortable: true,
            width: "150px",
        },
        {
            name: "Request Date",
            sortable: true,
            selector: (itm: any) => {

                const dateParts = itm.requestedDate.split("-");
                if (dateParts.length === 3) {

                    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                }

                return itm.requestedDate;
            },
            width: "150px"
        },
        // {
        //     name: "Request Date",
        //     sortable: true,
        //     selector: (itm: any) => itm.requestedDate,
        //     width: "150px"

        // },
        {
            name: "Request Status",
            sortable: true,
            width: "170px",
            cell: (itm: any) => (
                <>
                    <div className={itm.leaveStatus.status === "Approved" ? 'color_approve' : itm.leaveStatus.status === "Rejected" ? "color_deny" : "color_progress"}>{itm.leaveStatus.status}</div>
                </>
            )
        },
        {
            name: "Action",
            sortable: false,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ]

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);


    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Employee Leave Status
                                    </h3>
                                </div>

                            </div>

                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "2%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    dialogClassName="my-modal modal-dialog-centered"
                    // id="logouts-modal"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Leave</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}> Employee Name </label>
                                            <div>
                                                <IonInput value={empName} readonly className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Leave Type </label>
                                            <div>
                                                <IonInput value={leaveType} readonly className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Status </label>
                                            <div>
                                                <IonInput value={status} readonly className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>From Date </label>
                                            <div>
                                                <IonInput value={fromDate} readonly className="form-control datetimepicker" type="date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>To Date </label>
                                            <div>
                                                <IonInput value={toDate} readonly className="form-control datetimepicker" type="date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Total Days </label>
                                            <div>
                                                <IonInput value={noOfDays} readonly className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                                <div className="row">
                                <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Reason for Leave </label>
                                            <textarea value={leaveReason} readOnly className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Reporting Person's </label>
                                            <IonInput readonly value={reportingPerson} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Remarks</label>
                                            <div>
                                                <IonInput value={remarks} readonly className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="button" className="btn-primary submit-btn" onClick={() => closemodal()}>Back</button>
                            </div>

                        </form>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>

    )

}

export default AllApproval